/* ============================================================
   STILLA — Shopify asset resolver
   Maps the funnel's image filenames to their Shopify CDN URLs.
   ============================================================ */
window.STILLA_CDN = "https://cdn.shopify.com/s/files/1/1018/5290/5604/files/";
window.STILLA_IMG_MAP = {
  "bottle-card.png":"bottle-card.png?v=1784238560",
  "teddy-belly.png":"teddy-belly.png?v=1784231944",
  "teddy-before.png":"teddy-before.png?v=1784231944",
  "teddy-after.png":"teddy-after.png?v=1784231944",
  "ranger-paws.png":"ranger-paws.png?v=1784231944",
  "pearl-belly.png":"pearl-belly.png?v=1784231944",
  "milo-belly.png":"milo-belly.png?v=1784231945",
  "cooper-neck.png":"cooper-neck.png?v=1784231944",
  "luna-ear.png":"luna-ear.png?v=1784231944",
  "howto-food.png":"howto-food.png?v=1784231944",
  "stilla-vet-carter.webp":"stilla-vet-carter.webp?v=1784231942"
};
window.STILLA_ASSET = function(name){
  if(!name) return "";
  if(/^https?:/.test(name)) return name;
  var m = window.STILLA_IMG_MAP[name];
  return window.STILLA_CDN + (m || name);
};

/* ---- Responsive image sizing (Shopify CDN transforms) ----------------------
   The source PNGs are full-resolution (1.5–3 MB each). Shopify's CDN resizes
   on the fly via a `width` query param, so we never ship a 2 MB original to
   render an 88px thumbnail. IMGW() appends the width; SRCSET() builds a
   candidate list so the browser picks per-DPR/viewport.
   Only rewrites Shopify CDN URLs — anything else passes through untouched. */
window.STILLA_IMGW = function(url, w){
  if(!url || typeof url !== "string") return url || "";
  if(!/cdn\.shopify\.com/.test(url)) return url;   // non-CDN: leave alone
  if(/[?&]width=/.test(url)) return url;           // already sized
  return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
};
window.STILLA_SRCSET = function(url, widths){
  if(!url || !/cdn\.shopify\.com/.test(url)) return "";
  return widths.map(function(w){
    return window.STILLA_IMGW(url, w) + " " + w + "w";
  }).join(", ");
};
/* ============================================================
   STILLA — BRAND  (master wordmark — single source of truth)
   The bottle-label identity: lowercase "stilla", black letters,
   one orange-red dot over the i. NEVER an orange "a".

   Public API:
     STILLA.brand.wordmark({ variant, ariaLabel, decorative })
       variant: "default" (black ink) | "reverse" (cream ink) | "mono" (currentColor)
     STILLA.brand.mount()   // fills every [data-stilla-wordmark] element

   Usage in markup (no raw logo markup is ever duplicated — only mounts):
     <a class="brand" data-size="header" data-stilla-wordmark aria-label="Stilla home"></a>
     <div class="brand" data-size="footer" data-stilla-wordmark data-variant="default"
          role="img" aria-label="Stilla"></div>

   Geometry is measured from the bottle label:
   Fira Sans 700, dotless i (U+0131) + a precisely placed orange dot.
   ============================================================ */
(function(){
  var S = window.STILLA = window.STILLA || {};

  var INK     = 'var(--stilla-logo-ink,#141414)';
  var ACCENT  = 'var(--stilla-logo-accent,#FF4B24)';
  var REVERSE = 'var(--stilla-logo-reverse,#F7EEDC)';

  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  /* Returns the wordmark as an inline SVG string.
     viewBox is measured to the ink: letters + orange dot, tight clear-space baked. */
  function wordmark(opts){
    opts = opts || {};
    var ink = opts.variant === 'reverse' ? REVERSE
            : opts.variant === 'mono'    ? 'currentColor'
            : INK;
    var dot = opts.variant === 'mono'    ? 'currentColor' : ACCENT;

    // Accessibility: decorative by default (the link/element carries the label).
    var a11y = opts.decorative === false && opts.ariaLabel
      ? ' role="img" aria-label="' + esc(opts.ariaLabel) + '"'
      : ' aria-hidden="true" focusable="false"';

    return '<svg class="wm" xmlns="http://www.w3.org/2000/svg" viewBox="4 18 324 138"'
      + a11y + '>'
      + '<text class="wm__t" x="10" y="150"'
      + ' font-family="\'Fira Sans\',\'Archivo Black\',system-ui,sans-serif"'
      + ' font-weight="700" font-size="140" letter-spacing="-1" fill="' + ink + '">'
      + 'stılla</text>'  // dotless i — the dot is drawn below
      + '<circle class="wm__dot" cx="149" cy="40" r="17" fill="' + dot + '"/>'
      + '</svg>';
  }

  /* Fill every mount. Idempotent. Reads data-variant / data-label. */
  function mount(root){
    (root || document).querySelectorAll('[data-stilla-wordmark]').forEach(function(el){
      if(el.__wmDone) return;
      el.__wmDone = true;
      var variant = el.getAttribute('data-variant') || 'default';
      var isImgRole = el.getAttribute('role') === 'img';
      el.innerHTML = wordmark({
        variant: variant,
        ariaLabel: el.getAttribute('aria-label') || 'Stilla',
        decorative: !isImgRole   // if the element itself is role=img, label the SVG; else it's decorative
      });
    });
  }

  S.brand = { wordmark: wordmark, mount: mount };

  if(document.readyState !== 'loading') mount();
  else document.addEventListener('DOMContentLoaded', function(){ mount(); });
})();
/* ============================================================
   STILLA — HERO IMAGE GALLERY  (user-controlled; no autoplay)
   7 approved slides, slide 1 default. Thumbnails + arrows + dots +
   keyboard + swipe. Slide images resolve to Shopify CDN URLs.
   ============================================================ */
(function(){
  var CDN = window.STILLA_CDN || "https://cdn.shopify.com/s/files/1/1018/5290/5604/files/";

  // slide 1 = clean outcome hero (owner's 6 creatives follow); main + thumb are explicit CDN URLs
  var SLIDES = [
    { label:'Outcome',                     alt:'Calm Golden Retriever resting beside Stilla Barrier Drops.',
      main:CDN+'stilla-hero-outcome.webp?v=1784231912', thumb:CDN+'stilla-hero-outcome-thumb.webp?v=1784231942' },
    { label:'Before and after',            alt:'Before-and-after dog-skin comparison with Stilla Barrier Drops.',
      main:CDN+'herobeforeafter1.png?v=1784231658', thumb:CDN+'herobeforeafter1.png?v=1784231658' },
    { label:'Is Stilla right for your dog',alt:'Checklist of scratching, licking, hot spots, ear, belly, and restless-night problems.',
      main:CDN+'herorightforyourdog.png?v=1784231657', thumb:CDN+'herorightforyourdog.png?v=1784231657' },
    { label:'Why Stilla is different',     alt:'Most products chase the irritation; Stilla supports the barrier underneath.',
      main:CDN+'herosupportbarrier.png?v=1784231658', thumb:CDN+'herosupportbarrier.png?v=1784231658' },
    { label:'Formula',                     alt:'Stilla formula: collagen, MSM, hyaluronic acid, and vitamin C.',
      main:CDN+'heroformula.png?v=1784231658', thumb:CDN+'heroformula.png?v=1784231658' },
    { label:'How to use',                  alt:'One simple step every morning with food.',
      main:CDN+'herodailyroutine.png?v=1784231658', thumb:CDN+'herodailyroutine.png?v=1784231658' },
    { label:'Authority and trust',         alt:'Made with the standards you would expect — quality, testing, and purity.',
      main:CDN+'heroauthority.png?v=1784231658', thumb:CDN+'heroauthority.png?v=1784231658' }
  ];
  var N = SLIDES.length;
  function full(sl){ return sl.main; }
  function thumb(sl){ return sl.thumb; }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function init(){
    var root = document.querySelector('[data-hgal]'); if(!root) return;
    var mainImg   = root.querySelector('[data-hgal-main]');
    var thumbsWrap = root.querySelector('[data-hgal-thumbs]');
    var dotsWrap  = root.querySelector('[data-hgal-dots]');
    var live      = root.querySelector('[data-hgal-live]');
    var stage     = root.querySelector('.hgal__stage');
    if(!mainImg || !thumbsWrap) return;

    var idx = 0;
    var primed = false;   // false until the initial select(0); guards the hero double-fetch

    // scroll a thumbnail into view WITHIN its (horizontal) strip only — never scroll the page
    function keepThumbInView(t){
      var w = thumbsWrap, tl = t.offsetLeft, tw = t.offsetWidth, sl = w.scrollLeft, cw = w.clientWidth;
      if(w.scrollWidth <= cw) return;               // not scrollable → nothing to do
      if(tl < sl) w.scrollLeft = Math.max(0, tl - 8);
      else if(tl + tw > sl + cw) w.scrollLeft = tl + tw - cw + 8;
    }

    // ---- build thumbnails (real image, accessible label) ----
    thumbsWrap.innerHTML = SLIDES.map(function(sl, i){
      return '<button class="hgal__thumb" type="button" role="tab" data-i="' + i + '"'
        + ' aria-selected="' + (i===0?'true':'false') + '" tabindex="' + (i===0?'0':'-1') + '"'
        + ' aria-label="' + esc(sl.label) + '">'
        + '<span class="hgal__thumb-media"><img src="' + STILLA_IMGW(thumb(sl), 200) + '" srcset="' + STILLA_SRCSET(thumb(sl), [110, 200, 280]) + '" sizes="88px" alt="" loading="lazy" width="320" height="320" decoding="async"></span>'
        + '</button>';
    }).join('');
    if(dotsWrap){
      dotsWrap.innerHTML = SLIDES.map(function(sl, i){
        return '<button class="hgal__dot' + (i===0?' is-on':'') + '" type="button" data-i="' + i + '" tabindex="-1" aria-label="' + esc(sl.label) + '"></button>';
      }).join('');
    }
    var thumbs = [].slice.call(thumbsWrap.querySelectorAll('.hgal__thumb'));
    var dots   = dotsWrap ? [].slice.call(dotsWrap.querySelectorAll('.hgal__dot')) : [];

    // ---- select a slide (loads full image on demand; keeps prior frame until ready) ----
    function select(i, focusThumb){
      i = (i % N + N) % N;
      idx = i;
      var sl = SLIDES[i], target = i;
      mainImg.alt = sl.alt;                    // keep alt correct immediately (before load)
      root.setAttribute('data-slide', i);      // slide-0 shows badge + testimonial overlays; infographics hide them
      // preload then swap so the previous frame stays until the new one is ready (no white flash);
      // guard against rapid-click races — only apply if this is still the current slide
      // Slide 0 is already painted by the server-rendered <img srcset>, so the
      // first call must NOT re-fetch it — doing so downloaded the hero twice
      // (srcset pick + JS preload) and cost more than shipping one big file.
      // Later slide changes preload a CDN-resized copy then swap, so the
      // previous frame stays until the new one is ready (no white flash).
      if(primed){
        var pre = new Image();
        pre.onload  = function(){ if(idx === target){ mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = pre.src; mainImg.alt = sl.alt || mainImg.alt; } };
        pre.src = STILLA_IMGW(full(sl), 900);
      }
      primed = true;

      thumbs.forEach(function(t, ti){
        var on = ti === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-selected', on);
        if(on) keepThumbInView(t);   // horizontal-only; never scrolls the page
      });
      dots.forEach(function(d, di){ d.classList.toggle('is-on', di === i); });

      if(live) live.textContent = 'Image ' + (i+1) + ' of ' + N + ': ' + sl.label;
      if(focusThumb && thumbs[i]) thumbs[i].focus();
    }

    // ---- thumbnail clicks ----
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ select(+t.getAttribute('data-i')); }); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ select(+d.getAttribute('data-i')); }); });

    // ---- roving-tabindex keyboard on the tablist (Enter/Space native via button) ----
    thumbsWrap.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){ e.preventDefault(); select(idx+1, true); }
      else if(e.key === 'ArrowLeft' || e.key === 'ArrowUp'){ e.preventDefault(); select(idx-1, true); }
      else if(e.key === 'Home'){ e.preventDefault(); select(0, true); }
      else if(e.key === 'End'){ e.preventDefault(); select(N-1, true); }
    });

    // ---- arrows (loop) ----
    var prev = root.querySelector('[data-hgal-prev]'), next = root.querySelector('[data-hgal-next]');
    if(prev) prev.addEventListener('click', function(){ select(idx-1); });
    if(next) next.addEventListener('click', function(){ select(idx+1); });

    // ---- left/right arrow keys when the stage is focused ----
    if(stage){
      stage.addEventListener('keydown', function(e){
        if(e.key === 'ArrowLeft'){ e.preventDefault(); select(idx-1); }
        else if(e.key === 'ArrowRight'){ e.preventDefault(); select(idx+1); }
      });
      // ---- touch swipe (track last move position; robust across devices) ----
      var x0 = null, y0 = null, xL = null, yL = null;
      stage.addEventListener('touchstart', function(e){ var t = e.changedTouches[0]; x0 = xL = t.clientX; y0 = yL = t.clientY; }, { passive:true });
      stage.addEventListener('touchmove', function(e){ var t = e.changedTouches[0]; if(t){ xL = t.clientX; yL = t.clientY; } }, { passive:true });
      stage.addEventListener('touchend', function(){
        if(x0 == null) return;
        var dx = xL - x0, dy = yL - y0;
        if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) select(dx < 0 ? idx+1 : idx-1);
        x0 = y0 = xL = yL = null;
      }, { passive:true });
    }

    // slide 1 is already in the static <img>; sync state (no re-fetch — same URL is cached)
    select(0);
  }

  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
/* ============================================================
   STILLA — CONFIG  (feature flags + analytics + cart; edit here only)
   No build step. Classic script -> global STILLA_CONFIG.
   ============================================================ */
window.STILLA_CONFIG = {
  brandName: "Stilla",            // PROVISIONAL working name
  brandProvisional: true,

  features: {
    stickyMobileCta: true
  },

  /* PROOF INTEGRITY — every proof section is REAL-data-driven and HIDES itself when its
     data array is empty. Flip these
     on only once real, approved data is loaded into data.js. */
  proof: {
    heroProof: false,             // hero rating/vet line — off until real count + real DVM exist
    /* BUILD REVIEW: true => proof sections render full-size, clearly-labeled DEV PLACEHOLDER
       cards (never fake public names/results) so the complete PDP can be evaluated.
       Set false for PRODUCTION to hide any proof section that still lacks real data. */
    showPlaceholders: false
  },

  /* Analytics — placeholders only. DO NOT insert fake IDs. Event names stay identical. */
  analytics: {
    debug: true,
    metaPixelId: null,            // e.g. "1234567890" when ready
    ga4Id: null,                  // e.g. "G-XXXXXXX" when ready
    customEndpoint: null
  },

  /* CART ADAPTER — the public PDP is Add-to-Cart. No fake checkout.
     provider "none"  => cart works locally (add/remove/count); checkout shows an honest
                         "not connected yet" notice.
     provider "shopify" => set shopifyDomain + variantMap{ pkgId: numericVariantId } and
                         checkout builds a real Shopify cart permalink. */
  cart: {
    provider: "shopify",             // "none" | "shopify"
    shopifyDomain: "stilla-16.myshopify.com",          // e.g. "stilla.myshopify.com" or custom domain
    variantMap: {}                // { "1": 0, "3": 0, "5": 0 }  -> real Shopify variant IDs
  }
};
/* ============================================================
   STILLA — DATA  (single source of truth for copy + pricing + proof)
   PROOF INTEGRITY: testimonials / vets / caseStudies / beforeAfter / reviews are REAL-ONLY.
   They start EMPTY and their sections HIDE until real, approved data is added. Never fabricate.
   ============================================================ */
window.STILLA_DATA = {

  /* ---- PACKAGES — single source of truth for prices + subscription (edit here only) ----
     compareAt = retail value ($50 / bottle). Card shows: current price, struck compareAt, and
     SAVE (compareAt − current price) — computed live per purchase type. `save:true` = show the SAVE badge.
     Shopify IDs are placeholders — replace before subscription checkout can go live. */
  packages: [
    { id:"1", qty:1, name:"1 Bottle", sub:"Single Bottle",
      price:36.99, oneTimePrice:36.99, subscriptionPrice:29.99, compareAt:50.00, freeShip:false,
      note:"One bottle.", badge:null, save:false,
      refillInterval:30, refillIntervalUnit:"day",
      oneTimeVariantId:"52530562203780", subscriptionVariantId:"52530562203780", sellingPlanId:"692666073220", subInterval:"MONTH", subIntervalCount:1 },
    { id:"3", qty:3, name:"Buy 2, Get 1 Free", sub:"3-Bottle Bundle",
      price:74.99, oneTimePrice:74.99, subscriptionPrice:59.99, compareAt:150.00, freeShip:true,
      note:"Three bottles for the price of two.", badge:"MOST POPULAR", save:true, preselected:true,
      refillInterval:30, refillIntervalUnit:"day",
      oneTimeVariantId:"52530562236548", subscriptionVariantId:"52530562236548", sellingPlanId:"692666105988", subInterval:"MONTH", subIntervalCount:3 },
    { id:"5", qty:5, name:"Buy 3, Get 2 Free", sub:"5-Bottle Bundle",
      price:111.99, oneTimePrice:111.99, subscriptionPrice:89.99, compareAt:250.00, freeShip:true,
      note:"Five bottles for the price of three.", badge:"BEST VALUE", save:true,
      refillInterval:30, refillIntervalUnit:"day",
      oneTimeVariantId:"52530562269316", subscriptionVariantId:"52530562269316", sellingPlanId:"692666138756", subInterval:"MONTH", subIntervalCount:3 }
  ],

  /* ---- REAL-ONLY PROOF (empty => section hidden; fill with approved data to reveal) ---- */
  /* hero rating/vet line — enable via STILLA_CONFIG.proof.heroProof once BOTH are real */
  heroProof: { rating:null, count:null, vetName:null },   // e.g. rating:4.8, count:2143, vetName:"Dr. Jane Smith, DVM"

  testimonials: [], // legacy field, unused — the centralized `proof` array below drives both proof sections

  /* ---- CENTRALIZED CUSTOMER PROOF (single source for BOTH proof sections) ----
     featuredTop        -> short teaser card in "Dog parents can't stop talking" (renders shortQuote, ~15–30 words)
     featuredCaseStudy  -> detailed card in "Real dogs. Real results." (renders fullQuote + outcomeHeadline + before/after)
     REAL approved reviews only — never fabricate. `image` is the owner-supplied before/after composite (before | after).
     shortQuote is the customer's own words, condensed to card length; fullQuote is edited only for length/clarity. */
  proof: [
    { id:"teddy", topCategory:"Restless nights", caseCategory:"Belly & full-body irritation",
      outcomeHeadline:"The constant scratching finally stopped.",
      customerName:"Megan S.", dogName:"Teddy", breed:"Goldendoodle", rating:5, verified:true,
      image:"teddy-belly.png", bodyArea:"belly", timeline:null, featuredTop:true, featuredCaseStudy:false,
      shortQuote:"Some nights, neither of us slept. Now he’s sleeping through the night and playing again—it feels like Teddy can finally enjoy being a dog.",
      fullQuote:"Teddy’s belly had been pink, irritated, and covered in little crusty patches for so long that I started thinking this was just something we would always deal with. He licked himself constantly and could never fully relax—some nights, neither of us slept. We had already spent so much money trying different things. But little by little, the licking slowed down and his skin started looking calmer. He’s sleeping through the night, playing again, and curling up next to me without constantly stopping to scratch. I’m beyond thankful—it feels like Teddy can finally enjoy being a dog again." },

    { id:"ranger", topCategory:"Paw licking & chewing",
      customerName:"Joshua A.", dogName:"Ranger", breed:"Labrador", rating:5, verified:true,
      image:"ranger-paws.png", bodyArea:"paws", timeline:null, featuredTop:true, featuredCaseStudy:false,
      shortQuote:"For two years he chewed his paws raw. About three weeks after starting Stilla the licking stopped, and the skin between his toes finally healed.",
      fullQuote:"For two years, I watched him lick and chew his paws until they were red, stained, and sore. Prescription treatments would give him a little relief, but a few weeks later we’d be right back where we started. About three weeks after starting Stilla, I suddenly realized the licking had stopped. The redness is calming down, the staining has disappeared, and the skin between his toes has finally healed. I’m just so thankful we found something that finally made a difference." },

    { id:"pearl", topCategory:"Red, irritated belly",
      customerName:"Lulu Y.", dogName:"Pearl", breed:"Golden Retriever", rating:5, verified:true,
      image:"pearl-belly.png", bodyArea:"belly", timeline:null, featuredTop:true, featuredCaseStudy:false,
      shortQuote:"She was uncomfortable all the time and I felt helpless. Now her belly looks healthy, she isn’t obsessively licking, and she’s my playful girl again.",
      fullQuote:"This didn’t just change her skin—it gave us our happy girl back. Before, she was uncomfortable all the time and I felt helpless watching her suffer. Now her belly looks healthy, she isn’t obsessively licking, and she’s playful again. I could cry looking at the difference." },

    { id:"milo", caseCategory:"Belly & full-body irritation",
      outcomeHeadline:"The constant licking finally stopped.",
      customerName:"Shaylo M.", dogName:"Milo", breed:"French Bulldog", rating:5, verified:true,
      image:"milo-belly.png", bodyArea:"belly & inner legs", timeline:null, featuredTop:false, featuredCaseStudy:true,
      shortQuote:"Milo licked and bit his belly raw and some nights couldn’t settle. Now he leaves it alone, relaxes, and sleeps peacefully.",
      fullQuote:"I felt awful every time I saw Milo licking and biting at his belly and inner legs. His skin stayed red and irritated, and some nights he couldn’t settle enough to sleep. We tried changing his food, special shampoos, sprays—but the irritation always came back. After adding Stilla to his routine, I noticed him leaving the area alone. The redness calmed down, his skin began looking healthy again, and he could finally relax without constantly stopping to lick. Looking at these two pictures honestly makes me emotional—he’s comfortable, sleeping peacefully, and I’m so thankful we found something that finally made a difference." },

    { id:"cooper", caseCategory:"Recurring hot spots",
      outcomeHeadline:"The hot spot stopped coming back.",
      customerName:"Rachel T.", dogName:"Cooper", breed:"Golden Retriever", rating:5, verified:true,
      image:"cooper-neck.png", bodyArea:"neck", timeline:null, featuredTop:false, featuredCaseStudy:true,
      shortQuote:"Cooper’s hot spot kept coming back until Stilla—now the redness has settled and his fur is filling back in.",
      fullQuote:"Cooper’s hot spot kept coming back no matter what we tried. We did the cone, the sprays, the special baths—everything. The skin on his neck was so red and sensitive that he would pull away when I tried to check it. Since adding Stilla to his routine, the redness has settled, the skin looks healthy again, and his fur is slowly filling back in. Yesterday he leaned into my hand while I scratched his neck, and I almost cried. I’m just so grateful to have my happy boy back." },

    { id:"luna", caseCategory:"Ear itching & head shaking",
      outcomeHeadline:"The scratching stopped. The house went quiet.",
      customerName:"Amanda R.", dogName:"Luna", breed:"German Shepherd", rating:5, verified:true,
      image:"luna-ear.png", bodyArea:"ear", timeline:null, featuredTop:false, featuredCaseStudy:true,
      shortQuote:"I could hear Luna scratching from the other room. Now the house is quiet—she finally sleeps.",
      fullQuote:"I could hear Luna scratching her ear from the other room. She was shaking her head constantly, waking up at night, and rubbing the side of her face against anything she could find. Every time I looked inside her ear, my heart sank—it was so red and irritated, and I felt completely helpless. Then one night I realized the house was quiet. No scratching. No head shaking. She was just sleeping. Her ear finally looks calm and healthy again, and she looks comfortable. Seeing my girl finally get some peace means everything to me." }
  ],

  /* REAL approved hero testimonial (owner-confirmed early user; consent to use name + dog).
     `verified:true` — she made a real purchase of Stilla through her vet (an off-platform but genuine
     verified buyer). Keep the purchase record on file to substantiate the badge if ever challenged. */
  heroReview: { quote:"I cried. Three years of 2 a.m. paw licking… gone in three weeks.", name:"Michelle", dog:"Luna", breed:"Golden Retriever", rating:5, verified:true },

  /* DESIGN-ONLY fallback sample when no real hero review exists (review mode only; never shown in production). */
  heroSample: { quote:"She finally stopped licking her paws at night. She sleeps—and so do we.", who:"Sample name + dog name · breed" },
  /* REAL, owner-confirmed & consented veterinarian endorsement (licensed DVM; OK to name with credential).
     Keep his written consent + credential/license on file to substantiate this expert endorsement. */
  vets: [
    { name:"Dr. Michael Carter", credentials:"DVM", practice:"Small-Animal Veterinarian", photo:"stilla-vet-carter.webp",
      quote:"Most products chase the rash you can see. I recommend Stilla because it supports the skin barrier underneath—the layer that determines whether the scratching, licking, and hot spots keep coming back." }
  ],
  caseStudies: [],  // { dog, breed, age, before, after, usedFor, owner }
  beforeAfter: [  // { dog, breed, bodyArea, beforeImg, afterImg, usedFor, owner, permission:true } — bodyArea = which area the photos show (belly · side · back · neck · hot spot · ears · legs · tail · paws)
    { dog:"Teddy", breed:"Goldendoodle", bodyArea:"Belly", beforeImg:"teddy-before.png", afterImg:"teddy-after.png",
      usedFor:"Daily Stilla", owner:"Shared by Megan S.", permission:true }
  ],
  reviews: { avg:null, count:null, distribution:null, items:[] }, // items: { name,dog,breed,rating,text,date,verified,photo }

  /* ---- PROBLEM RECOGNITION (visible owner experiences) ---- */
  problem: [
    { ic:"scratch", feat:true,  t:"Constant scratching", d:"Back, sides, neck, belly—scratching that never fully settles." },
    { ic:"belly",               t:"Red or irritated belly", d:"Pink, warm skin hidden under the fur." },
    { ic:"hotspot", feat:true,  t:"Hot spots that keep returning", d:"One patch settles. Another appears somewhere else." },
    { ic:"paw", feat:true,      t:"Paw licking and chewing", d:"Wet paws. Red toes. Repetitive licking day and night." },
    { ic:"ear",                 t:"Ear itching and head shaking", d:"Scratching, rubbing, and repeated head shaking." },
    { ic:"chew",                t:"Face, legs, or tail chewing", d:"Chewing and biting anywhere the skin feels uncomfortable." }
  ],

  /* ---- FAILED ALTERNATIVES (cards) ---- */
  alternatives: [
    { icon:"🧴", name:"Shampoos & washes", why:"Calms the surface for a few days. Then the scratching starts again.", badge:"TEMPORARY RELIEF" },
    { icon:"🦴", name:"Chews & supplements", why:"Another jar. Another promise. Still licking, chewing, and scratching.", badge:"DIDN’T BREAK THE CYCLE" },
    { icon:"🩹", name:"Creams & balms", why:"Soothes one irritated spot while another appears somewhere else.", badge:"SURFACE-LEVEL FIX" },
    { icon:"🥣", name:"Food changes", why:"New food. New routine. Weeks of waiting—and the cycle still returns.", badge:"STILL CAME BACK" }
  ],

  /* ---- "SO WE BUILT STILLA" benefit blocks ---- */
  benefits: [
    { t:"No more scratching", d:"Supports the barrier underneath." },
    { t:"No more paw licking", d:"Helps quiet the itch-and-lick cycle." },
    { t:"No more restless nights", d:"Helps your dog settle and rest." },
    { t:"Whole-body support", d:"Paws, belly, ears, legs, and tail." },
    { t:"Daily drops", d:"Easy to add to regular meals." },
    { t:"No fishy oil", d:"A cleaner daily routine." }
  ],

  /* ---- MECHANISM ---- */
  mechanismCards: [
    { n:1, title:"What owners see", body:"Scratching, licking, chewing, ear rubbing, head shaking — the visible signal, wherever it shows up on the body.", img:"mechanism-wholebody-01.png" },
    { n:2, title:"What’s happening underneath", body:"A weakened skin barrier lets everyday irritants in, and the itch keeps returning.", img:"mechanism-barrier-01.png" },
    { n:3, title:"Where Stilla fits", body:"Drops added to food give the barrier daily support from the inside.", img:"mechanism-drops-01.png" }
  ],
  mechanism: {
    copy: "Your dog’s skin covers the whole body. When the barrier gets weak, irritants get through. Your dog scratches, licks, chews, rubs, or shakes trying to calm it. That stresses the skin even more. Then the cycle starts again.",
    steps: [
      "The barrier gets weak",
      "Irritants get through",
      "Scratching, licking, and chewing start",
      "The skin gets more irritated",
      "The cycle repeats"
    ],
    takeaway: "Support the barrier. Stop the cycle."
  },

  /* ---- VET SECTION (copy always; the real recommendation hides until vets[] is filled) ---- */
  vet: {
    headline: "Why veterinarians recommend Stilla.",
    line: "Because healthier skin starts with a stronger barrier.",
    copy: "Most products work on one spot at a time. Stilla supports the barrier across the whole skin—the layer that helps keep irritants out from paws and belly to ears, legs, and tail."
  },

  /* ---- COMPARISON  (vals: yes | some | temp | no) ---- */
  comparison: {
    columns: ["Chews","Fish Oils","Shampoos & Balms"],
    rows: [
      { label:"Supports the skin barrier underneath", vals:["yes","some","some","no"] },
      { label:"No more scratching and paw licking",   vals:["yes","some","some","temp"] },
      { label:"No more hot spots coming back",         vals:["yes","some","some","temp"] },
      { label:"Easy once-a-day routine",              vals:["yes","yes","yes","no"] },
      { label:"Added directly to food",               vals:["yes","no","yes","no"] },
      { label:"No hard chew",                         vals:["yes","no","yes","yes"] },
      { label:"No fishy smell",                       vals:["yes","yes","no","yes"] }
    ]
  },

  /* ---- COMPARISON (MOBILE) — consolidated competitor columns so the table fits a phone.
     vals = [STILLA, Skin Products, Itch Medicine]. Symbols: yes=green check, no=red X,
     some=dash (sometimes/depends), na=hollow circle (does not apply).
     OWNER: review these consolidated indicators before publishing. ---- */
  comparisonMobile: {
    columns: ["Skin Products", "Itch Medicine"],
    rows: [
      { label:"Supports the skin barrier underneath",   vals:["yes","no","no"] },
      { label:"Helps stop scratching and paw licking",  vals:["yes","some","some"] },
      { label:"Helps keep hot spots from coming back",  vals:["yes","no","some"] },
      { label:"Added directly to food",                 vals:["yes","na","no"] },
      { label:"No fishy smell",                         vals:["yes","no","yes"] }
    ]
  },

  /* ---- HOW TO USE ---- */
  howto: {
    copy: "Measure your dog’s daily serving, add it to their regular meal, and stay consistent.",
    steps: [
      { t:"Measure", d:"Fill the dropper to the serving shown for your dog’s weight." },
      { t:"Add", d:"Mix it into their regular food." },
      { t:"Repeat", d:"Serve once daily as part of their normal routine." }
    ]
  },

  /* ---- FAQ (final approved copy — 8 questions; answers as paragraph arrays; Q3 has a serving guide) ---- */
  faqs: [
    { q:"What is STILLA?", a:[
      "STILLA is a daily liquid supplement that helps strengthen the foundation of your dog’s skin health.",
      "Scratching, redness, hot spots, and rashes are the problems you can see. But those problems often begin when your dog’s skin barrier becomes weak.",
      "Most products focus on calming the irritation after it appears. STILLA supports the skin barrier itself, helping your dog’s skin stay stronger, more resilient, and better able to handle everyday irritants."
    ] },
    { q:"How does STILLA work?", a:[
      "Healthy skin starts with a strong skin barrier.",
      "The skin barrier is your dog’s first line of defense. When it gets weak, it can’t keep out everyday irritants as well. That’s when scratching, redness, and hot spots are more likely to show up.",
      "STILLA gives your dog key nutrients that help support that barrier. Over time, that helps the skin stay stronger and calmer.",
      "Most products just soothe the irritation you can see. STILLA works on the skin underneath—where healthy skin really starts."
    ] },
    { q:"How do I use STILLA?", a:[
      "Just add your dog’s daily amount to their food once a day and stir it in well."
    ], guide:{
      title:"Daily Serving Guide",
      tiers:[
        { w:"Under 25 lbs", lines:["1 mL a day","One bottle lasts about 2 months"] },
        { w:"25–60 lbs",   lines:["2 mL a day","One bottle lasts about 1 month"] },
        { w:"Over 60 lbs",  lines:["3 mL a day","One bottle lasts about 3 weeks"] }
      ]
    }, after:[
      "Use STILLA every day for the best results. Healthy skin takes time to rebuild, and using it daily gives your dog’s skin steady support."
    ] },
    { q:"How long until I see results?", a:[
      "Every dog is different, but many owners start to see changes in 2 to 4 weeks.",
      "The first signs are often less scratching and paw licking, calmer-looking skin, or your dog sleeping more soundly.",
      "Dogs that have had skin problems for a long time may need 5 to 8 weeks. Keep using STILLA every day so the skin barrier has time to become stronger."
    ] },
    { q:"Will my dog eat it, and does it smell fishy?", a:[
      "STILLA has a natural bacon flavor and mixes right into your dog’s food.",
      "It doesn’t have the strong fishy smell that many skin and coat oils have, so it’s easier to serve every day.",
      "Most dogs eat it as part of their normal meal—no tricks needed."
    ] },
    { q:"Can I use STILLA with Apoquel, Cytopoint, or other products?", a:[
      "Yes. You can add STILLA to your dog’s daily routine, even if they already use Apoquel, Cytopoint, or other skin products.",
      "STILLA works in a different way. It feeds the skin barrier every day instead of just calming the irritation you can see.",
      "Keep giving any medicine the way your vet told you to. STILLA works alongside it to help build stronger, healthier skin over time."
    ] },
    { q:"Is STILLA a subscription?", a:[
      "You can buy once, or subscribe for automatic delivery and save.",
      "Subscription refills arrive automatically so you never run out—the single bottle is delivered every month, and the 3- and 5-bottle bundles are delivered every 3 months.",
      "You can change or cancel anytime."
    ] },
    { q:"What is the 60-day guarantee?", a:[
      "Try STILLA for 60 days.",
      "Use it every day the way we suggest. If you’re not happy, just reach out within 60 days and we’ll refund you in full.",
      "No risk. No hassle."
    ] }
  ]
};
/* ============================================================
   STILLA — TRACKING
   dataLayer + console, Meta Pixel / GA4 bridges (stubbed, no fake IDs).
   Captures & persists UTMs + fbclid across every route and step.
   Global: STILLA.track, STILLA.attribution, STILLA.onView
   ============================================================ */
(function(){
  var CFG = window.STILLA_CONFIG || {};
  var A = (CFG.analytics || {});
  var KEY = "stilla_attribution";
  var ATTR_KEYS = ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","fbclid","gclid"];

  window.STILLA = window.STILLA || {};

  /* ---- Capture mode: ?capture=1 pauses animations for clean screenshots ---- */
  try{ if(new URLSearchParams(location.search).get('capture')) document.documentElement.classList.add('capture'); }catch(e){}

  /* ---- Attribution capture + persistence ---- */
  function loadStored(){
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch(e){ return {}; }
  }
  function captureAttribution(){
    var stored = loadStored();
    var params = new URLSearchParams(location.search);
    ATTR_KEYS.forEach(function(k){
      var v = params.get(k);
      if(v && !stored[k]) stored[k] = v;   // first-touch wins
    });
    if(!stored.landing_path) stored.landing_path = location.pathname;
    if(!stored.first_seen) stored.first_seen = new Date().toISOString();
    try { sessionStorage.setItem(KEY, JSON.stringify(stored)); } catch(e){}
    return stored;
  }
  var attribution = captureAttribution();

  /* Append persisted attribution to internal links so params survive navigation */
  function propagateLinks(){
    var qs = new URLSearchParams();
    ATTR_KEYS.forEach(function(k){ if(attribution[k]) qs.set(k, attribution[k]); });
    var str = qs.toString();
    if(!str) return;
    document.querySelectorAll('a[href]').forEach(function(a){
      var href = a.getAttribute('href');
      if(!href || href.startsWith('#') || href.startsWith('http') || href.startsWith('mailto') || href.startsWith('tel')) return;
      if(a.hasAttribute('data-no-utm')) return;
      a.href = href + (href.indexOf('?')>-1 ? '&' : '?') + str;
    });
  }

  /* ---- track() ---- */
  window.dataLayer = window.dataLayer || [];
  function track(event, params){
    var payload = Object.assign({ event:event, ts:Date.now() }, attribution, params||{});
    window.dataLayer.push(payload);
    if(A.debug) console.log("[track]", event, params||{});
    // Meta Pixel bridge — active only when a real Pixel is installed:
    if(window.fbq && A.metaPixelId){ try{ fbq('trackCustom', event, params||{}); }catch(e){} }
    // GA4 bridge:
    if(window.gtag && A.ga4Id){ try{ gtag('event', event, params||{}); }catch(e){} }
  }

  /* ---- one-time section view observer ---- */
  function onView(selector, event, params){
    var el = document.querySelector(selector);
    if(!el || !('IntersectionObserver' in window)) return;
    var fired = false;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting && !fired){ fired = true; track(event, params); io.disconnect(); }
      });
    }, { threshold:0.35 });
    io.observe(el);
  }

  window.STILLA.track = track;
  window.STILLA.onView = onView;
  window.STILLA.attribution = attribution;
  window.STILLA.propagateLinks = propagateLinks;

  document.addEventListener('DOMContentLoaded', propagateLinks);
})();
/* ============================================================
   STILLA — STORAGE  (reservation + package selection persistence)
   localStorage during development. Global: STILLA.store
   ============================================================ */
(function(){
  window.STILLA = window.STILLA || {};
  var PKG_KEY = "stilla_pkg";
  var RES_KEY = "stilla_reservation";

  /* Package selection is SESSION-scoped (sessionStorage), not localStorage:
     a completely fresh visit (new session / incognito / cleared storage) has no
     stored value, so the app falls back to the preselected 3-bottle bundle.
     A selection is only remembered within the current session (after an
     intentional click), and never leaks across sessions to override the default.
     Purge any legacy localStorage value so stale testing state can't select 1/5. */
  try { localStorage.removeItem(PKG_KEY); } catch(e){}

  function getPackageId(){
    try { return sessionStorage.getItem(PKG_KEY); } catch(e){ return null; }
  }
  function setPackageId(id){
    try { sessionStorage.setItem(PKG_KEY, id); } catch(e){}
  }
  function saveReservation(data){
    try { localStorage.setItem(RES_KEY, JSON.stringify(data)); } catch(e){}
  }
  function getReservation(){
    try { return JSON.parse(localStorage.getItem(RES_KEY)) || null; } catch(e){ return null; }
  }
  function clearReservation(){
    try { localStorage.removeItem(RES_KEY); } catch(e){}
  }

  window.STILLA.store = {
    getPackageId:getPackageId, setPackageId:setPackageId,
    saveReservation:saveReservation, getReservation:getReservation, clearReservation:clearReservation
  };
})();
/* ============================================================
   STILLA — COMPONENTS  (renderers + selection state + selector)
   Proof renderers: real data => real cards; empty + config.proof.showPlaceholders =>
   full-size, clearly-labeled DEV PLACEHOLDER cards (never fake public names/results);
   empty + placeholders OFF => return FALSE so app.js hides the section (production).
   Globals: STILLA.render, STILLA.selection, STILLA.money, STILLA.pkgById
   ============================================================ */
(function(){
  window.STILLA = window.STILLA || {};
  var D = window.STILLA_DATA || {};
  var CFG = window.STILLA_CONFIG || {};
  var IMG = "assets/img/";

  function money(n){ return "$" + Number(n).toFixed(2); }
  function pkgById(id){ return (D.packages||[]).find(function(p){ return p.id === id; }); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function stars(n){ n=Math.round(n||5); return '★★★★★'.slice(0,n)+'☆☆☆☆☆'.slice(0,5-n); }
  function SP(){ return !!(CFG.proof && CFG.proof.showPlaceholders); }
  function phImg(label, cls){ return '<div class="ph '+(cls||'')+'"><span class="ph__label">'+esc(label)+'</span></div>'; }

  /* ---- inline SVG bottle (package viz) ---- */
  function bottleSVG(){
    return '<svg viewBox="0 0 34 80" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<rect x="12" y="1" width="10" height="9" rx="1.5" fill="#c9922f" stroke="#111" stroke-width="2"/>'
      + '<rect x="9" y="9" width="16" height="6" rx="1" fill="#e3b45c" stroke="#111" stroke-width="2"/>'
      + '<rect x="4" y="15" width="26" height="63" rx="7" fill="#efbf6b" stroke="#111" stroke-width="2.5"/>'
      + '<rect x="8" y="30" width="18" height="34" rx="3" fill="#fff8ec" stroke="#111" stroke-width="2"/>'
      + '<circle cx="17" cy="40" r="3.2" fill="#B7F12A" stroke="#111" stroke-width="1.5"/>'
      + '<line x1="10" y1="50" x2="24" y2="50" stroke="#111" stroke-width="1.5"/>'
      + '<line x1="10" y1="56" x2="20" y2="56" stroke="#111" stroke-width="1.5"/></svg>';
  }
  function cartonSVG(){
    return '<svg viewBox="0 0 60 84" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<path d="M6 20 L30 8 L54 20 L54 78 L6 78 Z" fill="#f2e3c5" stroke="#111" stroke-width="2.5"/>'
      + '<path d="M6 20 L30 32 L54 20" fill="none" stroke="#111" stroke-width="2"/>'
      + '<line x1="30" y1="32" x2="30" y2="78" stroke="#111" stroke-width="2"/></svg>';
  }
  function dropSVG(){
    return '<svg viewBox="0 0 34 44" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<path d="M17 2 C17 2 4 20 4 30 a13 13 0 0 0 26 0 C30 20 17 2 17 2 Z" fill="#efbf6b" stroke="#111" stroke-width="2.5"/></svg>';
  }
  function bottleStack(qty){
    var n = Math.min(qty, 6), s='';
    for(var i=0;i<n;i++){ s += bottleSVG(); }
    return '<div class="pkg__viz" aria-hidden="true">'+s+'</div>';
  }
  window.STILLA_SVG = { bottle:bottleSVG, carton:cartonSVG, drop:dropSVG };

  /* ---- PACKAGE CARDS ---- */
  /* shallow V/fan of REAL bottles per quantity — front-center largest & on top, rear bottles
     ~80–90% scaled, slightly raised + offset and overlapping so the group stays compact.
     {x: horizontal px, y: vertical px (negative = raised behind), s: scale, z: stack order} */
  var BOTTLE_FAN = {
    "1": [ {x:0,   y:0,   s:1.13, z:5} ],
    "3": [ {x:-30, y:-15, s:0.85, z:2}, {x:30, y:-15, s:0.85, z:2},
           {x:0,   y:0,   s:1,    z:5} ],
    "5": [ {x:-56, y:-30, s:0.80, z:1}, {x:56, y:-30, s:0.80, z:1},
           {x:-30, y:-15, s:0.90, z:3}, {x:30, y:-15, s:0.90, z:3},
           {x:0,   y:0,   s:1,    z:5} ]
  };
  function bottleFan(qty){
    var q = String(qty);
    var slots = BOTTLE_FAN[q] || BOTTLE_FAN["1"];
    var bundleAlt = q === '5' ? 'STILLA Barrier Drops five-bottle bundle'
                  : q === '3' ? 'STILLA Barrier Drops three-bottle bundle'
                  : 'STILLA Barrier Drops bottle';
    var frontIdx = slots.length - 1;   // last slot is the front/center bottle
    return slots.map(function(b, i){
      var front = i === frontIdx;
      return '<img class="pkg__b" src="'+STILLA_IMGW(STILLA_ASSET('bottle-card.png'), 400)+'"'
        + (front ? ' alt="'+bundleAlt+'"' : ' alt="" aria-hidden="true"')
        + ' loading="lazy" '
        + 'style="transform:translateX(-50%) translate('+b.x+'px,'+b.y+'px) scale('+b.s+');z-index:'+b.z+'">';
    }).join('');
  }

  function renderPackages(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    mount.innerHTML = (D.packages||[]).map(function(p, i){
      var mid  = (i === 1) ? ' pkg--mid' : '';
      var flag = p.badge ? '<span class="pkg__flag">'+esc(p.badge)+'</span>' : '';
      var save = p.save ? '<span class="pkg__save" data-card-save>SAVE '+money((p.compareAt||0) - p.subscriptionPrice)+'</span>' : '';
      var oneWas = p.compareAt ? money(p.compareAt) : '';
      var onePer = money(p.oneTimePrice / p.qty) + ' / bottle';
      var ship = p.freeShip ? '<div class="pkg__ship">Free shipping</div>' : '';
      var balt = 'Stilla Barrier Drops bottle' + (p.qty > 1 ? ' — '+p.qty+' bottles' : '');
      return '<button type="button" class="pkg'+mid+'" role="radio" aria-checked="false" data-pkg="'+p.id+'">'
        + flag + save
        + '<span class="pkg__check" aria-hidden="true">✓</span>'
        + '<div class="pkg__media" role="img" aria-label="'+esc(balt)+'"><div class="pkg__group">'+bottleFan(p.qty)+'</div></div>'
        + '<div class="pkg__qty">'+esc(p.name)+'</div>'
        + '<div class="pkg__name">'+esc(p.sub)+'</div>'
        + '<div class="pkg__price"><span class="pkg__now" data-card-now>'+money(p.oneTimePrice)+'</span><span class="pkg__was" data-card-was>'+oneWas+'</span></div>'
        + '<div class="pkg__per" data-card-per>'+onePer+'</div>'
        + ship
        + '<div class="pkg__cadence" data-card-cadence></div>'
        + '<span class="pkg__add">Add to Cart</span>'
        + '</button>';
    }).join('');
  }

  /* ---- PROBLEM RECOGNITION ---- */
  /* one consistent line-icon family: black outline, small orange detail, cream chip (no emoji/3D) */
  var PROB_ICONS = {
    scratch:'<path d="M5 20 L12 7"/><path d="M10 21 L17 8" stroke="var(--orange)"/><path d="M15 21 L21 10"/>',
    belly:'<path d="M5 12c0-4 3-6 7-6s7 2 7 6-3 6-7 6-7-2-7-6z"/><circle cx="10" cy="11" r="1" fill="var(--orange)" stroke="none"/><circle cx="14.5" cy="13" r="1" fill="var(--orange)" stroke="none"/><circle cx="11.5" cy="14.5" r="1" fill="var(--orange)" stroke="none"/>',
    hotspot:'<circle cx="12" cy="12.5" r="3" fill="var(--orange)" stroke="none"/><path d="M19.5 8.5A8 8 0 1 0 20.5 15"/><path d="M20.5 4.5v4.2h-4.2"/>',
    paw:'<ellipse cx="12" cy="16" rx="5" ry="4"/><circle cx="6.6" cy="10.5" r="1.9"/><circle cx="11" cy="8" r="1.9"/><circle cx="16" cy="9" r="1.9"/><circle cx="12" cy="16" r="1.2" fill="var(--orange)" stroke="none"/>',
    ear:'<path d="M9 4C6 5 5 9 5 13c0 4 1 7 4 7 2.2 0 3.2-2 3.2-5 0-2 1-3 1-6 0-3-2-5-4.2-5z"/><path d="M9 9c-1 1-1.2 3-1.2 5" stroke="var(--orange)"/>',
    chew:'<path d="M5 8h14"/><path d="M6.5 8v3l1.8 2 1.7-2 1.8 2 1.7-2 1.8 2 1.7-2V8"/><path d="M9 18c1.6 1.4 4.4 1.4 6 0" stroke="var(--orange)"/>'
  };
  function probIcon(key){
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+(PROB_ICONS[key]||'')+'</svg>';
  }
  function renderProblem(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    mount.innerHTML = (D.problem||[]).map(function(x){
      return '<div class="prob'+(x.feat?' prob--feat':'')+'">'
        + '<div class="prob__ic" aria-hidden="true">'+probIcon(x.ic)+'</div>'
        + '<h4>'+esc(x.t)+'</h4><p>'+esc(x.d)+'</p></div>';
    }).join('');
  }

  /* ---- FAILED ALTERNATIVES ---- */
  function renderAlternatives(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    mount.innerHTML = (D.alternatives||[]).map(function(a){
      var badge = a.badge ? '<span class="alt__badge">'+esc(a.badge)+'</span>' : '';
      return '<div class="alt"><span class="alt__x" aria-hidden="true">✕</span>'
        + '<div class="alt__viz" aria-hidden="true">'+a.icon+'</div>'
        + '<h4 class="alt__title">'+esc(a.name)+'</h4>'
        + '<p class="alt__why">'+esc(a.why)+'</p>'
        + badge + '</div>';
    }).join('');
  }

  /* ---- "SO WE BUILT STILLA" benefit blocks ---- */
  function renderBenefits(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    mount.innerHTML = (D.benefits||[]).map(function(b){
      return '<li class="btile"><span class="btile__t">'+esc(b.t)+'</span>'
        + '<span class="btile__d">'+esc(b.d)+'</span></li>';
    }).join('');
  }

  /* ---- MECHANISM: 3 science cards ---- */
  function renderMechanismCards(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    mount.innerHTML = (D.mechanismCards||[]).map(function(m){
      return '<div class="mcard mcard--'+m.n+'"><span class="mcard__num">'+m.n+'</span>'
        + '<div class="mcard__media">'+phImg('ILLUSTRATION · '+m.img)+'</div>'
        + '<div class="mcard__body"><h4>'+esc(m.title)+'</h4><p>'+esc(m.body)+'</p></div></div>';
    }).join('');
  }

  /* ---- MECHANISM 5-STEP CYCLE ---- */
  var CYCLE_ICONS = ['🛡️','⚡','🐕','🔻','🔁'];
  function renderCycle(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    var steps = (D.mechanism && D.mechanism.steps) || [];
    mount.innerHTML = steps.map(function(t,i){
      var last = i === steps.length-1;
      return '<div class="cstep">'
        + '<span class="cstep__ic" aria-hidden="true">'+(CYCLE_ICONS[i]||'●')+'</span>'
        + '<span class="cstep__t"><span class="cstep__n">STEP '+(i+1)+'</span>'+esc(t)+'</span>'
        + '<span class="cstep__arrow" aria-hidden="true">'+(last?'↺':'→')+'</span></div>';
    }).join('');
  }

  /* ---- COMPARISON (yes | some | temp | no) ---- */
  function cmpCell(v){
    if(v==='yes')  return '<span class="yes" aria-label="Yes">✓</span>';
    if(v==='no')   return '<span class="no" aria-label="No">✕</span>';
    if(v==='temp') return '<span class="cmp-word cmp-temp">Temporary</span>';
    return '<span class="cmp-word cmp-some">Sometimes</span>';
  }
  function cmpCellMob(v){
    if(v==='yes') return '<span class="cmpm cmpm--y" role="img" aria-label="Yes">✓</span>';
    if(v==='no')  return '<span class="cmpm cmpm--n" role="img" aria-label="No">✕</span>';
    if(v==='na')  return '<span class="cmpm cmpm--na" role="img" aria-label="Does not apply"></span>';
    return '<span class="cmpm cmpm--p" role="img" aria-label="Sometimes or depends">–</span>';
  }
  function cmpTable(c, cell, extraCls){
    var brand = esc(CFG.brandName||'Stilla');
    var head = '<tr><th></th><th class="col-us">'+brand+'</th>'
      + c.columns.map(function(col){ return '<th>'+esc(col)+'</th>'; }).join('') + '</tr>';
    var body = c.rows.map(function(r){
      var uscell = '<td class="col-us">'+cell(r.vals[0])+'</td>';
      var rest = r.vals.slice(1).map(function(v){ return '<td>'+cell(v)+'</td>'; }).join('');
      return '<tr><td>'+esc(r.label)+'</td>'+uscell+rest+'</tr>';
    }).join('');
    return '<table class="compare'+(extraCls||'')+'"><thead>'+head+'</thead><tbody>'+body+'</tbody></table>';
  }
  function renderComparison(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    var desk = '<div class="cmp__scroll cmp--desk">'+cmpTable(D.comparison||{columns:[],rows:[]}, cmpCell, '')+'</div>';
    var mob = D.comparisonMobile ? '<div class="cmp--mob">'+cmpTable(D.comparisonMobile, cmpCellMob, ' compare--mob')+'</div>' : '';
    mount.innerHTML = desk + mob;
  }

  /* ---- HOW TO USE ---- */
  function renderHowto(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    var steps = (D.howto && D.howto.steps) || [];
    var icons = ['💧','🥣','📅'];   // dropper · food bowl · daily/calendar
    mount.innerHTML = steps.map(function(s,i){
      return '<li class="hstep">'
        + '<span class="hstep__n" aria-hidden="true">'+('0'+(i+1))+'</span>'
        + '<span class="hstep__ic" aria-hidden="true">'+(icons[i]||'•')+'</span>'
        + '<span class="hstep__body"><span class="hstep__t">'+esc(s.t)+'</span>'
        + '<span class="hstep__d">'+esc(s.d)+'</span></span></li>';
    }).join('');
  }

  /* ---- FAQ ---- */
  function renderFAQ(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return;
    mount.innerHTML = (D.faqs||[]).map(function(f,i){
      var paras = Array.isArray(f.a) ? f.a : (f.a ? [f.a] : []);
      var body = paras.map(function(p){ return '<p>'+esc(p)+'</p>'; }).join('');
      if(f.guide){
        body += '<div class="qa__guide">';
        if(f.guide.title) body += '<div class="qa__guide-t">'+esc(f.guide.title)+'</div>';
        (f.guide.tiers||[]).forEach(function(t){
          body += '<div class="qa__tier"><span class="qa__tier-w">'+esc(t.w)+'</span><ul>'
            + (t.lines||[]).map(function(l){ return '<li>'+esc(l)+'</li>'; }).join('')
            + '</ul></div>';
        });
        body += '</div>';
      }
      (f.after||[]).forEach(function(p){ body += '<p>'+esc(p)+'</p>'; });
      return '<div class="qa" aria-expanded="false">'
        + '<button class="qa__q" aria-controls="qa-'+i+'"><span class="qa__ic" aria-hidden="true">+</span><span>'+esc(f.q)+'</span></button>'
        + '<div class="qa__a" id="qa-'+i+'" role="region">'+body+'</div></div>';
    }).join('');
  }

  /* ============================================================
     PROOF renderers (real | placeholder | hidden)
     ============================================================ */

  /* before/after composite image + BEFORE/AFTER corner labels (shared by both proof sections) */
  function baImg(r){
    var alt = esc(r.dogName + ' — before and after (' + (r.bodyArea||'skin') + ')');
    var src = STILLA_ASSET(r.image);
    return '<img src="'+STILLA_IMGW(src, 800)+'" srcset="'+STILLA_SRCSET(src, [400, 600, 800, 1100])+'" sizes="(max-width:767px) 92vw, 360px" alt="'+alt+'" loading="lazy" decoding="async">'
      + '<span class="ba-tag ba-tag--before">Before</span>'
      + '<span class="ba-tag ba-tag--after">After</span>';
  }

  /* TOP proof: short scannable teaser cards — "Dog parents can't stop talking" (featuredTop) */
  function renderTestimonials(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return false;
    var list = (D.proof || []).filter(function(r){ return r.featuredTop; });
    if(!list.length){ mount.innerHTML=''; return false; }
    mount.innerHTML = list.map(function(r){
      var ver = r.verified ? '<span class="pcard__ver">✓ Verified</span>' : '';
      return '<article class="pcard">'
        + '<div class="pcard__ba">'+baImg(r)+'</div>'
        + '<div class="pcard__body">'
        +   '<div class="pcard__cat">'+esc(r.topCategory || r.caseCategory || '')+'</div>'
        +   '<p class="pcard__q">“'+esc(r.shortQuote)+'”</p>'
        +   '<div class="stars pcard__stars" aria-hidden="true">'+stars(r.rating)+'</div>'
        +   '<div class="pcard__who">'+esc(r.customerName)+' + '+esc(r.dogName)+' · '+esc(r.breed)+' '+ver+'</div>'
        + '</div></article>';
    }).join('');
    return true;
  }

  function renderVet(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return false;
    var list = D.vets || [];
    if(list.length){
      mount.innerHTML = list.map(function(v){
        var photo = v.photo ? '<img class="vet__headshot" src="'+STILLA_IMGW(STILLA_ASSET(v.photo), 140)+'" alt="'+esc(v.name)+'" loading="lazy" decoding="async" width="56" height="56">' : '';
        return '<figure class="vet"><blockquote class="vet__q">“'+esc(v.quote)+'”</blockquote>'+photo
          + '<figcaption class="vet__who"><b>'+esc(v.name)+'</b>'
          + (v.credentials?'<span>'+esc(v.credentials)+'</span>':'')
          + (v.practice?'<span class="vet__practice">'+esc(v.practice)+'</span>':'')+'</figcaption></figure>';
      }).join('');
      return true;
    }
    if(!SP()){ mount.innerHTML=''; return false; }
    mount.innerHTML = '<figure class="vet vet--ph">'+phImg('VET PHOTO','vet__ph-img')
      + '<blockquote class="vet__q ph-text">“VETERINARIAN QUOTE TO INSERT”</blockquote>'
      + '<figcaption class="vet__who ph-text"><b>VETERINARIAN NAME</b><span>CREDENTIALS · DVM</span>'
      + '<span class="vet__practice">PRACTICE / PROFESSIONAL DESCRIPTION</span></figcaption></figure>';
    return true;
  }

  /* LOWER proof: detailed static case studies — "Real dogs. Real results." (featuredCaseStudy) */
  function renderCaseStudies(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return false;
    var list = (D.proof || []).filter(function(r){ return r.featuredCaseStudy; });
    if(!list.length){ mount.innerHTML=''; return false; }
    mount.innerHTML = list.map(function(r){
      var ver = r.verified ? ' · <span class="case__ver">✓ Verified</span>' : '';
      var tl  = r.timeline ? '<div class="case__time">'+esc(r.timeline)+'</div>' : '';
      return '<article class="case">'
        + '<div class="case__ba">'+baImg(r)+'</div>'
        + '<div class="case__body">'
        +   '<div class="case__cat">'+esc(r.caseCategory || r.topCategory || '')+'</div>'
        +   '<div class="stars case__stars" aria-hidden="true">'+stars(r.rating)+'</div>'
        +   '<h3 class="case__headline">'+esc(r.outcomeHeadline || '')+'</h3>'
        +   '<p class="case__q">“'+esc(r.fullQuote)+'”</p>'
        +   '<div class="case__who"><b>'+esc(r.dogName)+' · '+esc(r.breed)+'</b>'
        +     '<span class="case__by">Review by '+esc(r.customerName)+ver+'</span></div>'
        +   tl
        + '</div></article>';
    }).join('');
    return true;
  }

  function renderBeforeAfter(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return false;
    var list = (D.beforeAfter||[]).filter(function(b){ return b.beforeImg && b.afterImg && b.permission; });
    var after, before, note;
    if(list.length){
      var b = list[0];
      var areaTag = b.bodyArea ? '<span class="ba__area">'+esc(b.bodyArea)+'</span> ' : '';   // which area this before/after shows
      var aSrc = STILLA_ASSET(b.afterImg), bSrc = STILLA_ASSET(b.beforeImg);
      var baSizes = '(max-width:767px) 96vw, 900px';
      after  = '<img src="'+STILLA_IMGW(aSrc, 900)+'" srcset="'+STILLA_SRCSET(aSrc, [500, 750, 900, 1200])+'" sizes="'+baSizes+'" decoding="async" alt="After — '+esc([b.bodyArea,b.dog].filter(Boolean).join(' — '))+'">';
      before = '<img src="'+STILLA_IMGW(bSrc, 900)+'" srcset="'+STILLA_SRCSET(bSrc, [500, 750, 900, 1200])+'" sizes="'+baSizes+'" decoding="async" alt="Before — '+esc([b.bodyArea,b.dog].filter(Boolean).join(' — '))+'">';
      note   = '<p class="ba__note">'+areaTag+[b.dog,b.breed].filter(Boolean).map(esc).join(' · ')+(b.usedFor?' · '+esc(b.usedFor):'')+(b.owner?' · '+esc(b.owner):'')+'</p>';
    } else if(SP()){
      after  = phImg('AFTER IMAGE TO INSERT','ba__ph');
      before = phImg('BEFORE IMAGE TO INSERT','ba__ph');
      note   = '<p class="ba__note ph-text">BODY AREA (belly · side · back · neck · hot spot · ears · legs · tail · paws) · DOG NAME · BREED · USED FOR · OWNER — real permissioned photos only</p>';
    } else { mount.innerHTML=''; return false; }
    mount.innerHTML =
      '<div class="ba" id="baSlider">'
      + '<div class="ba__pane ba__pane--after"><div class="ba__fill">'+after+'</div></div>'
      + '<div class="ba__pane ba__pane--before"><div class="ba__fill">'+before+'</div></div>'
      + '<span class="ba__lbl ba__lbl--before">Before</span><span class="ba__lbl ba__lbl--after">After</span>'
      + '<div class="ba__divider"></div><div class="ba__grip" aria-hidden="true">⇄</div>'
      + '<input class="ba__range" type="range" min="0" max="100" value="50" step="1" aria-label="Reveal before and after"></div>' + note;
    return true;
  }

  function renderReviews(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return false;
    var r = D.reviews || {}; var list = r.items || [];
    if(list.length){
      var dist = r.distribution || {};
      var rows = [5,4,3,2,1].map(function(s){ var pct=dist[s]||0; return '<div class="rdist__row"><span>'+s+'★</span><div class="rdist__bar"><i style="width:'+pct+'%"></i></div><span>'+pct+'%</span></div>'; }).join('');
      var summary = '<div class="rsummary"><div class="rsummary__avg"><b>'+esc(r.avg)+'</b><span class="stars">'+stars(r.avg)+'</span><span class="rsummary__count">'+esc(r.count)+' reviews</span></div><div class="rdist">'+rows+'</div></div>';
      var cards = list.map(function(it){
        var photo = it.photo ? '<img class="rev__ph" src="'+STILLA_ASSET(it.photo)+'" alt="" loading="lazy">' : '';
        var ver = it.verified ? '<span class="rev__ver">✓ Verified</span>' : '';
        return '<article class="rev"><div class="stars">'+stars(it.rating)+'</div><p>'+esc(it.text)+'</p>'+photo
          + '<div class="rev__who">'+esc([it.name,it.dog].filter(Boolean).join(' + '))+(it.breed?', '+esc(it.breed):'')+' <span class="rev__when">'+esc(it.date||'')+'</span> '+ver+'</div></article>';
      }).join('');
      mount.innerHTML = summary + '<div class="rev-grid">'+cards+'</div>';
      return true;
    }
    if(!SP()){ mount.innerHTML=''; return false; }
    var prows = [5,4,3,2,1].map(function(s){ return '<div class="rdist__row"><span>'+s+'★</span><div class="rdist__bar"><i style="width:0%"></i></div><span class="ph-text">—</span></div>'; }).join('');
    var summaryP = '<div class="rsummary"><div class="rsummary__avg"><b class="ph-text">—</b><span class="stars ph-stars">★★★★★</span><span class="rsummary__count ph-text">REVIEW COUNT TO INSERT</span></div><div class="rdist">'+prows+'</div></div>';
    var chips = '<div class="rfilters" aria-hidden="true"><span class="rchip is-on">All</span><span class="rchip">5★</span><span class="rchip">4★</span><span class="rchip">With photos</span><span class="rchip">Verified</span></div>';
    var cardsP='';
    for(var i=0;i<3;i++){
      cardsP += '<article class="rev rev--ph"><div class="stars ph-stars" aria-hidden="true">★★★★★</div>'
        + '<p class="ph-text">CUSTOMER REVIEW TO INSERT</p>'+phImg('PHOTO','rev__ph-img')
        + '<div class="rev__who ph-text">CUSTOMER NAME + DOG, BREED <span class="rev__when">DATE</span> ✓ Verified</div></article>';
    }
    mount.innerHTML = summaryP + chips + '<div class="rev-grid">'+cardsP+'</div>';
    return true;
  }

  /* ---- HERO testimonial overlay (real | placeholder | hidden) ---- */
  function renderHeroTestimonial(mountSel){
    var mount = document.querySelector(mountSel); if(!mount) return false;
    var t = D.heroReview || (D.testimonials || [])[0];   // dedicated hero review keeps the rail untouched
    if(t){
      var who = [t.name, t.dog].filter(Boolean).join(' + ');
      var tail = (t.breed ? ' · ' + esc(t.breed) : '') + (t.verified ? ' · Verified' : '');
      mount.innerHTML = '<span class="stars" aria-hidden="true">'+stars(t.rating)+'</span>'
        + '<p class="hero__tcard__q">“'+esc(t.quote)+'”</p>'
        + '<p class="hero__tcard__who">— '+esc(who)+tail+'</p>';
      return true;
    }
    if(!SP()){ mount.innerHTML=''; return false; }
    // review-mode SAMPLE only — clearly labeled, no "Verified" claim; hidden in production until a real approved review exists
    var s = D.heroSample || {};
    mount.innerHTML = '<span class="hero__tcard__tag">Sample copy · not a published review</span>'
      + '<span class="stars ph-stars" aria-hidden="true">★★★★★</span>'
      + '<p class="hero__tcard__q ph-text">“'+esc(s.quote || 'CUSTOMER QUOTE TO INSERT')+'”</p>'
      + '<p class="hero__tcard__who ph-text">— '+esc(s.who || 'CUSTOMER NAME + DOG NAME · BREED')+'</p>';
    return true;
  }

  /* ---- SHARED PURCHASE STATE (package + purchase type; single source of truth) ---- */
  var subs = [];
  var purchaseType = 'one_time';           // 'one_time' | 'subscription' — one-time is the default; subscription is opt-in (not highlighted on landing)
  var current = (function(){
    var stored = window.STILLA.store && window.STILLA.store.getPackageId();
    if(stored && pkgById(stored)) return stored;
    var pre = (D.packages||[]).find(function(p){ return p.preselected; });
    return pre ? pre.id : (D.packages[0] && D.packages[0].id);
  })();
  /* canonical single-bottle price — savings are always measured vs buying qty of these */
  var SINGLE_BOTTLE = (function(){ var one = (D.packages||[]).find(function(x){ return x.qty === 1; }); return one ? one.oneTimePrice : 39.99; })();
  /* centralized truthful savings % for ANY package + purchase type (never hard-coded).
     Base = compare-at (MSRP); price = the SELECTED purchase price (one-time or Subscribe & Save).
     savingsPercent = round((compareAt - price) / compareAt * 100). */
  function savingsPct(p, isSub){
    if(!p || !p.compareAt) return 0;
    var base  = p.compareAt;
    var price = isSub ? p.subscriptionPrice : p.oneTimePrice;
    return base > price ? Math.round((base - price) / base * 100) : 0;
  }
  function getPurchase(){
    var p = pkgById(current);
    var sub = purchaseType === 'subscription';
    return {
      id: current, selectedPackageId: current, pkg: p,
      purchaseType: purchaseType, quantity: p.qty,
      oneTimePrice: p.oneTimePrice, subscriptionPrice: p.subscriptionPrice,
      displayedPrice: sub ? p.subscriptionPrice : p.oneTimePrice,
      compareAtPrice: p.compareAt || null,   // ALWAYS the bundle MSRP ($50/$150/$250) — never the alternate purchase mode's price
      individualValue: p.qty * SINGLE_BOTTLE,
      savingsPct: savingsPct(p, sub),
      refillInterval: p.refillInterval, refillIntervalUnit: p.refillIntervalUnit,
      variantId: sub ? p.subscriptionVariantId : p.oneTimeVariantId,
      sellingPlanId: sub ? p.sellingPlanId : null
    };
  }
  var selection = {
    get:function(){ return pkgById(current); },
    getId:function(){ return current; },
    getPurchase: getPurchase,
    set:function(id, source){
      if(!pkgById(id) || id===current){ if(id===current) notify(); return; }
      current = id;
      if(window.STILLA.store) window.STILLA.store.setPackageId(id);
      if(window.STILLA.track) window.STILLA.track("PackageSelected", packageParams(source));
      notify();
    },
    setPurchaseType:function(t, source){
      t = (t === 'subscription') ? 'subscription' : 'one_time';
      if(t === purchaseType) return;
      purchaseType = t;
      if(window.STILLA.track) window.STILLA.track("PurchaseTypeChanged", { purchaseType:t, intendedPackage:current, source:source||'toggle' });
      notify();
    },
    subscribe:function(fn){ subs.push(fn); }
  };
  function notify(){ var st = getPurchase(); subs.forEach(function(fn){ try{ fn(st); }catch(e){} }); }
  function packageParams(source){
    var st = getPurchase();
    return { intendedPackage:st.id, packageName:st.pkg.name+' — '+st.pkg.sub, price:st.displayedPrice, purchaseType:st.purchaseType, source:source||'unknown' };
  }

  window.STILLA.getPurchase = getPurchase;
  window.STILLA.render = {
    packages:renderPackages, problem:renderProblem, alternatives:renderAlternatives,
    benefits:renderBenefits, mechanismCards:renderMechanismCards, cycle:renderCycle,
    comparison:renderComparison, howto:renderHowto, faq:renderFAQ,
    testimonials:renderTestimonials, vet:renderVet, caseStudies:renderCaseStudies,
    beforeAfter:renderBeforeAfter, reviews:renderReviews, heroTestimonial:renderHeroTestimonial
  };
  window.STILLA.money = money;
  window.STILLA.pkgById = pkgById;
  /* Cadence text derived from the package's REAL Shopify selling-plan interval
     (subInterval/subIntervalCount, read from the live plan — not a hardcoded phrase).
     MONTH/1 -> "every month" · MONTH/3 -> "every 3 months" · generic for any interval. */
  window.STILLA.cadenceText = function(p){
    var n = (p && p.subIntervalCount) || 1;
    var unit = ((p && p.subInterval) || 'MONTH').toLowerCase();
    return n === 1 ? ('every ' + unit) : ('every ' + n + ' ' + unit + 's');
  };
  window.STILLA.deliveredText = function(p){ return 'Delivered ' + window.STILLA.cadenceText(p); };
  window.STILLA.bottleFan = bottleFan;   // reused by the sticky offer bar thumbnail
  window.STILLA.savingsPct = savingsPct; // centralized savings calc
  window.STILLA.selection = selection;
  window.STILLA.packageParams = packageParams;
})();
/* ============================================================
   STILLA — CART ADAPTER  (backed by the REAL Shopify Ajax Cart API)
   Add-to-Cart POSTs to /cart/add.js with { id: variantId, quantity, selling_plan? }, so a
   subscription line carries a real selling-plan allocation that is retained through checkout.
   The drawer renders from /cart.js (subscription state = line.selling_plan_allocation, price =
   line.final_line_price) — never from local UI state. Checkout is a same-origin redirect to /checkout.
   ============================================================ */
(function(){
  window.STILLA = window.STILLA || {};
  var S = window.STILLA;
  var CFG = (window.STILLA_CONFIG || {}).cart || { provider:"none" };
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  var el = null;
  var CART = { items: [], item_count: 0, total_price: 0 };   // mirror of the REAL Shopify cart (/cart.js)

  function packages(){ return (window.STILLA_DATA && window.STILLA_DATA.packages) || []; }
  function pkg(id){ return S.pkgById ? S.pkgById(id) : packages().find(function(p){ return p.id === id; }); }
  function pkgByVariant(vid){ vid = String(vid); return packages().find(function(p){ return String(p.subscriptionVariantId) === vid || String(p.oneTimeVariantId) === vid; }); }
  function money(n){ return S.money ? S.money(n) : ("$"+Number(n).toFixed(2)); }   // n in dollars
  function items(){ return CART.items || []; }
  function count(){ return CART.item_count || 0; }
  function subtotal(){ return (CART.total_price || 0) / 100; }                       // Shopify cents -> dollars

  function postJSON(url, data){
    return fetch(url, { method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" }, body: JSON.stringify(data) })
      .then(function(r){ if(!r.ok){ return r.json().catch(function(){ return {}; }).then(function(j){ throw (j || {}); }); } return r.json(); });
  }
  function refresh(){
    return fetch(ROOT + "cart.js", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(c){ if(c && c.items){ CART = c; } return CART; });
  }

  /* Add to the REAL Shopify cart. Subscription lines carry the numeric selling_plan id so a
     selling-plan allocation is attached to the cart line and retained through checkout. */
  function add(pkgId, source){
    var p = pkg(pkgId); if(!p) return;
    var st = S.getPurchase ? S.getPurchase() : null;
    var sub = !!(st && st.id === pkgId && st.purchaseType === "subscription");
    var vid = sub ? p.subscriptionVariantId : p.oneTimeVariantId;
    if(!vid || String(vid).indexOf("REPLACE") !== -1) return;
    var item = { id: Number(vid), quantity: 1 };
    if(sub && p.sellingPlanId && String(p.sellingPlanId).indexOf("REPLACE") === -1){ item.selling_plan = Number(p.sellingPlanId); }
    S.track && S.track("AddToCart", { intendedPackage:p.id, packageName:p.name+" — "+p.sub, price:(sub?p.subscriptionPrice:p.oneTimePrice), purchaseType:(sub?"subscription":"one_time"), quantity:1, source:source||"pdp" });
    open(); setCartNotice("");
    postJSON(ROOT + "cart/add.js", { items:[item] })
      .then(refresh)
      .then(paint)
      .catch(function(){ refresh().then(paint); setCartNotice("Sorry — we couldn’t add that just now. Please try again."); });
  }
  function remove(key){
    if(!key) return;
    postJSON(ROOT + "cart/change.js", { id:String(key), quantity:0 })
      .then(function(c){ if(c && c.items){ CART = c; } paint(); })
      .catch(function(){ refresh().then(paint); });
  }
  function setCartNotice(msg){
    var n = el && el.querySelector('[data-cart-notice]');
    if(!n) return;
    if(msg){ n.textContent = msg; n.hidden = false; } else { n.textContent = ''; n.hidden = true; }
  }

  function mount(){
    if(el) return;
    el = document.createElement('div');
    el.className = 'cart'; el.setAttribute('role','dialog'); el.setAttribute('aria-modal','true'); el.setAttribute('aria-label','Cart');
    var mark = (S.brand && S.brand.wordmark) ? S.brand.wordmark({ variant:'default', ariaLabel:'Stilla' }) : '';
    el.innerHTML = '<div class="cart__panel"><div class="cart__head">'
      + '<span class="cart__headL"><span class="brand cart__brand">' + mark + '</span>'
      + '<span class="cart__title">Your cart</span></span>'
      + '<button class="cart__close" aria-label="Close cart">×</button></div>'
      + '<div class="cart__body" data-cart-body></div><div class="cart__foot" data-cart-foot></div></div>';
    document.body.appendChild(el);
    el.querySelector('.cart__close').addEventListener('click', close);
    el.addEventListener('click', function(e){ if(e.target===el) close(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && el.classList.contains('open')) close(); });
  }

  function paint(){
    document.querySelectorAll('[data-cart-count]').forEach(function(n){ var c=count(); n.textContent=c; n.classList.toggle('has', c>0); });
    if(!el) return;
    var body = el.querySelector('[data-cart-body]'), foot = el.querySelector('[data-cart-foot]'), list = items();
    if(!list.length){ body.innerHTML = '<p class="cart__empty">Your cart is empty.</p>'; foot.innerHTML=''; return; }
    body.innerHTML = list.map(function(l){
      // subscription wording is derived from the REAL Shopify line (selling_plan_allocation), not local UI state
      var sub = !!l.selling_plan_allocation;
      var p = pkgByVariant(l.variant_id || l.id);
      var name = p ? p.name : (l.product_title || 'Stilla');
      var subLabel = p ? p.sub : (l.variant_title || '');
      var meta = sub ? ('Subscribe & Save · ' + S.deliveredText(p)) : 'One-time'; if(p && p.freeShip) meta += ' · Free shipping';
      return '<div class="cart__line"><div><div class="cart__ln">'+name+'</div>'
        + '<div class="cart__ls">'+subLabel+' · '+meta+(l.quantity>1?(' · ×'+l.quantity):'')+'</div></div>'
        + '<div class="cart__lr"><span class="cart__lp">'+money((l.final_line_price||0)/100)+'</span>'
        + '<button class="cart__rm" data-rm="'+l.key+'" aria-label="Remove">Remove</button></div></div>';
    }).join('');
    body.querySelectorAll('[data-rm]').forEach(function(b){ b.addEventListener('click', function(){ remove(b.getAttribute('data-rm')); }); });
    foot.innerHTML = '<div class="cart__sub"><span>Subtotal</span><b>'+money(subtotal())+'</b></div>'
      + '<button class="btn btn--primary btn--block cart__checkout">Checkout</button>'
      + '<p class="cart__trust">60-Day Money-Back Guarantee · Secure Checkout · Free U.S. Shipping on 3+ Bottles</p>'
      + '<div class="cart__notice" data-cart-notice hidden></div>';
    foot.querySelector('.cart__checkout').addEventListener('click', checkout);
  }

  function open(){ mount(); paint(); el.classList.add('open'); document.body.style.overflow='hidden'; }
  function close(){ if(el){ el.classList.remove('open'); document.body.style.overflow=''; } }

  /* Items are already in the REAL Shopify cart (with selling-plan allocations), so checkout is a
     straight, same-origin redirect — no cross-domain permalink, no ?selling_plan to be dropped. */
  function checkout(){
    if(!items().length) return;
    S.track && S.track("InitiateCheckout", { value:subtotal(), items:items().length });
    window.location.href = ROOT + "checkout";
  }

  S.cart = { add:add, remove:remove, items:items, count:count, open:open, close:close, checkout:checkout, paint:paint, refresh:refresh };
  document.addEventListener('DOMContentLoaded', function(){ refresh().then(paint).catch(function(){ paint(); }); });
})();
/* ============================================================
   STILLA — BEFORE/AFTER SLIDER (clip-path; robust to missing images)
   Mouse + touch + keyboard accessible. Global: STILLA.initBeforeAfter
   ============================================================ */
(function(){
  window.STILLA = window.STILLA || {};
  function clamp(v,min,max){ return Math.max(min, Math.min(max, v)); }

  function initBeforeAfter(rootSel){
    var root = document.querySelector(rootSel); if(!root) return;
    var before  = root.querySelector('.ba__pane--before');
    var divider = root.querySelector('.ba__divider');
    var grip    = root.querySelector('.ba__grip');
    var range   = root.querySelector('.ba__range');

    function setPct(pct){
      pct = clamp(pct, 0, 100);
      if(before)  before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      if(divider) divider.style.left = pct + '%';
      if(grip)    grip.style.left = pct + '%';
      if(range){ range.setAttribute('aria-valuenow', Math.round(pct)); range.value = pct; }
    }
    function pctFromClientX(clientX){
      var r = root.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    }

    var dragging = false;
    function down(e){ dragging = true; move(e); }
    function up(){ dragging = false; }
    function move(e){
      if(!dragging) return;
      var x = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
      setPct(pctFromClientX(x));
      if(e.cancelable) e.preventDefault();
    }

    root.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    root.addEventListener('touchstart', down, {passive:false});
    window.addEventListener('touchmove', move, {passive:false});
    window.addEventListener('touchend', up);

    if(range){
      range.addEventListener('input', function(){ setPct(Number(range.value)); });
      range.addEventListener('keydown', function(e){
        var cur = Number(range.value);
        if(e.key==='ArrowLeft'){ setPct(cur-5); e.preventDefault(); }
        if(e.key==='ArrowRight'){ setPct(cur+5); e.preventDefault(); }
      });
    }
    setPct(50);
  }
  window.STILLA.initBeforeAfter = initBeforeAfter;
})();
/* ============================================================
   STILLA — APP  (per-page bootstrap / orchestration)
   Detects page via <body data-page>. Null-safe across all routes.
   Public PDP = Add-to-Cart. Proof sections hide when their real data is empty.
   ============================================================ */
(function(){
  var S = window.STILLA || {};
  var page = document.body.getAttribute('data-page') || 'pdp';

  document.addEventListener('DOMContentLoaded', function(){
    common();
    if(page === 'pdp') initPDP();
    if(page === 'reserve') initReserve();
    if(page === 'thankyou') initThankYou();
    if(page === 'advertorial') initAdvertorial();
  });

  function common(){
    S.track && S.track('PageView', { page:page });
    var toggle = document.querySelector('.menu-toggle');
    var menu = document.querySelector('.mobile-menu');
    if(toggle && menu){
      toggle.addEventListener('click', function(){ menu.classList.toggle('open'); });
      menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ menu.classList.remove('open'); }); });
    }
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href');
        if(id.length>1){ var t = document.querySelector(id); if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth'}); } }
      });
    });
  }

  function hideSection(sel){ var el = document.querySelector(sel); if(el) el.style.display = 'none'; }

  /* ---------- PDP ---------- */
  function initPDP(){
    S.track && S.track('ViewContent', { content_name:'PDP', intendedPackage:S.selection.getId() });

    /* content sections (always shown) */
    S.render.packages('#pkgGrid');
    S.render.problem('#problemGrid');
    S.render.alternatives('#altGrid');
    S.render.benefits('#benefitGrid');
    /* mechanism is now a static connected itch-cycle diagram (no card/step renderers) */
    S.render.comparison('#cmpMount');
    S.render.howto('#howtoSteps');
    S.render.faq('#faqMount');

    /* real-only proof sections — hide the whole section when empty */
    if(!S.render.testimonials('#testimonialRail')) hideSection('#testimonials'); else initTestimonialDots('#testimonialRail');
    function initTestimonialDots(sel){
      var rail = document.querySelector(sel); if(!rail) return;
      var cards = [].slice.call(rail.querySelectorAll('.pcard')); if(cards.length < 2) return;
      if(rail.parentNode.querySelector('.proof-dots')) return;
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'proof-dots'; dotsWrap.setAttribute('role','tablist'); dotsWrap.setAttribute('aria-label','Owner stories');
      cards.forEach(function(c, i){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'proof-dot' + (i===0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Story ' + (i+1) + ' of ' + cards.length);
        b.addEventListener('click', function(){ c.scrollIntoView({ behavior:'smooth', inline:'start', block:'nearest' }); });
        dotsWrap.appendChild(b);
      });
      rail.parentNode.insertBefore(dotsWrap, rail.nextSibling);
      var dots = [].slice.call(dotsWrap.querySelectorAll('.proof-dot'));
      function setActive(i){ dots.forEach(function(d, di){ var on = di===i; d.classList.toggle('is-on', on); d.setAttribute('aria-selected', on ? 'true':'false'); }); }
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting && e.intersectionRatio >= 0.6){ setActive(cards.indexOf(e.target)); } });
        }, { root: rail, threshold:[0.6] });
        cards.forEach(function(c){ io.observe(c); });
      }
    }
    if(!S.render.vet('#vetMount'))                 hideSection('#vetrec');
    if(!S.render.caseStudies('#caseGrid'))         hideSection('#results');
    if(!S.render.beforeAfter('#baMount'))          hideSection('#beforeafter'); else S.initBeforeAfter && S.initBeforeAfter('#baSlider');
    /* standalone reviews-platform section removed — no public review submission / rating summary / count */

    /* hero proof line — approved default; upgrades to real numbers/vet only when data + flag on */
    heroProof();
    /* hero testimonial overlay — real => card; empty + placeholders => DEV card; empty + off => hidden */
    if(!S.render.heroTestimonial('[data-hero-testimonial]')){ var htc = document.querySelector('[data-hero-testimonial]'); if(htc) htc.style.display = 'none'; }

    wireSelector();
    wireSubscription();
    wireCart();
    wireFAQ();
    initOfferbar();

    S.onView('#mechanism','MechanismSectionViewed');
    S.onView('#comparison','ComparisonViewed');
  }

  function heroProof(){
    var host = document.querySelector('[data-hero-proof]'); if(!host) return;
    var cfg = (window.STILLA_CONFIG.proof||{});
    var hp = (window.STILLA_DATA.heroProof||{});
    // Only replace the approved default line with REAL numbers/vet when both are supplied.
    if(cfg.heroProof && hp.rating && hp.count){
      var line2 = hp.vetName ? '<span class="hero__proof-sub">Recommended by ' + hp.vetName + '</span>' : '';
      host.innerHTML = '<span class="hero__proof-line"><span class="stars" aria-hidden="true">★★★★★</span> '
        + '<span class="hero__proof-txt">' + hp.rating + '/5 from ' + hp.count + ' dog parents</span></span>' + line2;
    }
    // else: keep the approved default ("Loved by dog parents. Recommended by veterinarians.") — no fabricated numbers/names
  }

  function wireSelector(){
    var grid = document.querySelector('#pkgGrid'); if(!grid) return;
    grid.querySelectorAll('.pkg').forEach(function(card){
      card.addEventListener('click', function(){ S.selection.set(card.getAttribute('data-pkg'), 'buybox'); });
    });
    S.selection.subscribe(updatePurchaseUI);
    updatePurchaseUI(S.selection.getPurchase());  // initial paint (one-time, middle bundle)
  }

  /* automatic-refill toggle (CHECKED by default) — whole dashed module is the label */
  function wireSubscription(){
    var input = document.querySelector('[data-sub-input]');
    if(!input) return;
    input.checked = (S.selection.getPurchase().purchaseType === 'subscription');
    input.addEventListener('change', function(){
      S.selection.setPurchaseType(input.checked ? 'subscription' : 'one_time', 'sub_toggle');
    });
  }

  /* one function drives every purchasing component from the shared purchase state */
  function updatePurchaseUI(st){
    var p = st.pkg, sub = st.purchaseType === 'subscription';
    var disp = S.money(st.displayedPrice);
    var was = sub ? S.money(st.oneTimePrice) : '';
    var cadence = sub ? S.deliveredText(p) : '';   // per-package, from the real selling-plan interval
    var nameFull = p.name + ' · ' + p.sub;

    // keep the yellow selected bundle intact + update EVERY card's price to the current purchase type
    document.querySelectorAll('.pkg').forEach(function(card){
      var cp = S.pkgById(card.getAttribute('data-pkg')); if(!cp) return;
      var on = cp.id === p.id;
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
      var cardPrice  = sub ? cp.subscriptionPrice : cp.oneTimePrice;
      var cardStrike = cp.compareAt || null;               // retail compare-at, both purchase types
      var now = card.querySelector('[data-card-now]');
      var was = card.querySelector('[data-card-was]');
      var per = card.querySelector('[data-card-per]');
      var cad = card.querySelector('[data-card-cadence]');
      var sav = card.querySelector('[data-card-save]');
      if(now) now.textContent = S.money(cardPrice);   // no "/mo"; cadence shown on its own line below
      if(was) was.textContent = cardStrike ? S.money(cardStrike) : '';
      if(per) per.textContent = S.money(cardPrice / cp.qty) + ' / bottle';
      if(cad) cad.textContent = sub ? S.deliveredText(cp) : '';   // e.g. "Delivered every 3 months" per this card's real plan
      if(sav && cp.compareAt) sav.textContent = 'SAVE ' + S.money(cp.compareAt - cardPrice);  // live SAVE $ amount
    });

    // hero savings starburst — truthful % vs the bundle's "N single bottles" base; updates on bundle + refill toggle
    updateHeroBadge(p, sub);

    // main Add to Cart button price ("$79.99 · Add to Cart")
    setTextAll('[data-btn-price]', disp);

    // order summary
    setText('[data-sum-name]', nameFull);
    setText('[data-sum-total]', disp);
    setText('[data-sum-was]', p.compareAt ? S.money(p.compareAt) : '');   // retail compare-at (matches the cards)
    setText('[data-sum-cadence]', cadence);
    // savings row — [SAVE X% pill] + "You save $Y today" (same % as the sticky bar).
    // Hidden when there is no compare-at, compare-at <= price, or the honest discount rounds to 0%.
    var saveAmt = p.compareAt ? (p.compareAt - st.displayedPrice) : 0;
    var sumSave = document.querySelector('[data-sum-save]');
    if(sumSave){
      if(st.savingsPct > 0 && saveAmt > 0){
        sumSave.innerHTML = '<span class="summary__pct">SAVE ' + st.savingsPct + '%</span><span class="summary__amt">You save ' + S.money(saveAmt) + ' today</span>';
        sumSave.hidden = false;
      } else {
        sumSave.hidden = true;
      }
    }

    // sticky offer bar — mirrors the shared purchase state
    syncOfferbar(st);

    // guarantee + final CTA offer lines
    setTextAll('[data-offer-name]', nameFull);
    setTextAll('[data-offer-total]', disp);
    setTextAll('[data-offer-was]', was);
    setTextAll('[data-offer-cadence]', sub ? ('Subscribe & Save · ' + S.deliveredText(p) + ' · Cancel anytime') : '');

    // subscription module always shows the refill offer for the selected bundle:
    // price on line 1, real cadence ("Delivered every 3 months") on line 2
    var subPriceEl = document.querySelector('[data-sub-price]');
    if(subPriceEl){
      // amount + cadence in the SAME black as the main price typography (var(--black)).
      // Set here (element level) so it holds regardless of the .subopt__price stylesheet rule;
      // the cadence span has no color of its own and inherits this. Source rule is also --black.
      subPriceEl.style.color = 'var(--black)';
      subPriceEl.innerHTML = S.money(p.subscriptionPrice)
        + '<span class="subopt__cad" style="display:block;font-size:12px;font-weight:600;margin-top:2px">' + S.deliveredText(p) + '</span>';
    }
  }
  /* hero starburst — uses the SAME shared savingsPct() (compareAt vs selected price) so values can't drift. */
  function updateHeroBadge(p, sub){
    var badge = document.querySelector('[data-hero-badge]'); if(!badge) return;
    var pct = S.savingsPct(p, sub);   // exported from the selection module (this IIFE is a different scope)
    if(pct > 0){
      var pctEl = badge.querySelector('[data-badge-pct]'); if(pctEl) pctEl.textContent = pct + '%';
      var subEl = badge.querySelector('[data-badge-sub]'); if(subEl) subEl.textContent = sub ? 'WITH SUBSCRIBE & SAVE' : String(p.sub).toUpperCase();
      badge.hidden = false;
    } else {
      badge.hidden = true; // no compare-at advantage => no honest %, hide
    }
  }

  function setText(sel, txt){ var el = document.querySelector(sel); if(el) el.textContent = txt; }
  function setTextAll(sel, txt){ document.querySelectorAll(sel).forEach(function(el){ el.textContent = txt; }); }

  /* Add to Cart everywhere (buying modules + branded CTAs) */
  function wireCart(){
    document.querySelectorAll('[data-add-cart]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var src = btn.getAttribute('data-add-cart') || 'pdp';
        if(src === 'final') S.track && S.track('FinalCTAClicked');
        S.cart.add(S.selection.getId(), src);
      });
    });
    document.querySelectorAll('[data-cart-open]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); S.cart.open(); });
    });
    document.querySelectorAll('[data-scroll-packages]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); var t=document.querySelector('#packages'); if(t) t.scrollIntoView({behavior:'smooth'}); });
    });
    S.cart && S.cart.paint();
  }

  function wireFAQ(){
    document.querySelectorAll('.faq .qa__q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var qa = btn.closest('.qa');
        var panel = qa.querySelector('.qa__a');
        var open = qa.getAttribute('aria-expanded') === 'true';
        qa.setAttribute('aria-expanded', open ? 'false' : 'true');
        if(panel){ panel.style.maxHeight = open ? '' : panel.scrollHeight + 'px'; }
        if(!open) S.track && S.track('FAQOpened', { question: btn.textContent.trim() });
      });
    });
  }

  /* offer bar content sync — driven by the same shared purchase state as the selector */
  var offerbarLastLive = '';
  function syncOfferbar(st){
    var bar = document.querySelector('[data-offerbar]'); if(!bar) return;
    var p = st.pkg, sub = st.purchaseType === 'subscription';
    var disp = S.money(st.displayedPrice);

    setText('[data-offerbar-total]', disp);
    setText('[data-offerbar-was]', st.compareAtPrice ? S.money(st.compareAtPrice) : '');
    setText('[data-offerbar-mqty]', (p.qty === 1 ? '1 Bottle' : p.qty + ' Bottles') + ' ·');

    // truthful savings vs buying the same count individually (centralized) — hidden at 0%
    var saveEl = bar.querySelector('[data-offerbar-save]');
    if(saveEl){
      if(st.savingsPct > 0){ setText('[data-offerbar-pct]', st.savingsPct + '%'); saveEl.hidden = false; }
      else saveEl.hidden = true;
    }

    // supporting lines — cadence only for automatic refill
    setText('[data-offerbar-meta-d]', sub ? ('Subscribe & Save · ' + S.deliveredText(p) + ' · Cancel anytime') : (p.sub + ' · One-time purchase'));
    setText('[data-offerbar-meta-m]', sub ? 'Subscribe & Save' : 'One-time purchase');

    // bottle imagery matching the selected bundle (only re-render when qty changes)
    var thumb = bar.querySelector('[data-offerbar-thumb]');
    if(thumb && S.bottleFan){ var want = String(p.qty); if(thumb.getAttribute('data-qty') !== want){ thumb.innerHTML = S.bottleFan(p.qty); thumb.setAttribute('data-qty', want); } }

    // announce meaningful purchase-state changes (polite; skip duplicates so it isn't noisy)
    var live = bar.querySelector('[data-offerbar-live]');
    if(live){
      var msg = p.name + ', ' + disp + (sub ? (', Subscribe & Save, ' + S.deliveredText(p).toLowerCase() + ', cancel anytime') : ', one-time purchase');
      if(msg !== offerbarLastLive){ live.textContent = msg; offerbarLastLive = msg; }
    }
  }

  /* offer bar visibility + CTA — appears after the bundle selector scrolls out of view (upward) */
  function initOfferbar(){
    var bar = document.querySelector('[data-offerbar]'); if(!bar) return;
    if(!(window.STILLA_CONFIG.features && window.STILLA_CONFIG.features.stickyMobileCta)) return;

    // hand visibility to CSS transforms (remove the display:none fallback) — stays off-screen until .show
    bar.hidden = false; bar.setAttribute('aria-hidden','true');

    // CTA reuses the exact same S.cart.add as the main offer button, with a duplicate-submit guard
    var cta = bar.querySelector('[data-offerbar-cta]');
    var busy = false;
    if(cta){
      cta.addEventListener('click', function(e){
        e.preventDefault();
        if(busy) return;
        busy = true; cta.setAttribute('aria-busy','true');
        S.track && S.track('StickyCTAClicked', { intendedPackage:S.selection.getId(), purchaseType:S.getPurchase().purchaseType });
        S.cart.add(S.selection.getId(), 'sticky');
        setTimeout(function(){ busy = false; cta.removeAttribute('aria-busy'); }, 900);
      });
    }

    function setShown(on){
      bar.classList.toggle('show', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      // mobile coordination: same visibility state drives hiding the top sticky header (CSS handles the mobile-only + transition)
      document.documentElement.classList.toggle('stilla-atc-visible', on);
    }

    var selector = document.querySelector('#packages');
    if(selector && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        var e = entries[entries.length - 1];
        // show only once the selector has scrolled UP past the top of the viewport (not before reaching it)
        setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(selector);
    }
  }

  /* ---------- legacy /reserve (kept as reference; not linked from public PDP) ---------- */
  function initReserve(){
    if(document.querySelector('#reservePkg') && S.render.packages){
      S.render.packages('#reservePkg');
      document.querySelectorAll('#reservePkg .pkg').forEach(function(card){
        card.addEventListener('click', function(){ S.selection.set(card.getAttribute('data-pkg'),'reserve_page'); });
      });
      S.selection.subscribe(function(p){
        document.querySelectorAll('#reservePkg .pkg').forEach(function(card){ card.classList.toggle('is-selected', card.getAttribute('data-pkg')===p.id); });
      });
      var cur = S.selection.get();
      document.querySelectorAll('#reservePkg .pkg').forEach(function(card){ card.classList.toggle('is-selected', card.getAttribute('data-pkg')===cur.id); });
    }
    S.reservation && S.reservation.mountInline('#reserveForm', '../thank-you/');
  }
  function initThankYou(){ S.reservation && S.reservation.renderThankYou('#thankyouMount'); }
  function initAdvertorial(){
    S.track && S.track('AdvertorialView');
    document.querySelectorAll('[data-advertorial-cta]').forEach(function(a){
      a.addEventListener('click', function(){ S.track && S.track('AdvertorialCTA'); });
    });
  }
})();
